export default "__VITE_ASSET__99038832__"